import { FC, useState } from 'react';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import FundBreakdownContainer from './FundBrekdownContainer/FundBreakdownContainer.component';
import MancoSummaryContainer from './MancoSummaryContainer/MancoSummaryContainer.component';
import { Grid } from '@mui/material';
import { DataObject } from '../../../../types/redux/data/dataTypes';
import { useMancoReportDeliveryStatus } from './services/queries';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';

const ReportDeliveryOversight: FC<
  GeneralOverviewPageRenderedComponentProps
> = () => {
  const [filterState, setFilterState] = useState<string>('');
  const [weekStartDate, setWeekStartDate] = useState(new Date());

  const { data, isLoading, isError, error } =
    useMancoReportDeliveryStatus(weekStartDate);
  return (
    <QueryBoundary
      isLoading={isLoading}
      isError={isError}
      data={data}
      loadingMessages={['Loading Oversight Data...', 'Just a moment...', '...']}
      errorMessage={'An error occurred while loading oversight data.'}
      noDataMessage={'No oversight data available.'}
    >
      {(resolvedData) => {
        const fundStatusData: DataObject = {
          error: isError ? (error as Error) : null,
          isFetching: isLoading,
          data: resolvedData ? [resolvedData] : [],
        };
        return (
          <Grid container spacing={2} style={{ padding: 8 }}>
            <MancoSummaryContainer data={fundStatusData} />
            <FundBreakdownContainer
              data={fundStatusData}
              filterState={filterState}
              setFilterState={setFilterState}
              weekStartDate={weekStartDate}
              setWeekStartDate={setWeekStartDate}
            />
          </Grid>
        );
      }}
    </QueryBoundary>
  );
};

export default ReportDeliveryOversight;
